import { __awaiter, __generator } from "tslib";
/**
 * Download File from URL fetches the file contents from the given URL, and triggers a download of the file with the
 * specified filename.
 *
 * @param sourceUrl The URL to fetch the file from
 * @param filename  The name of the downloaded file
 */
export var downloadFileFromUrl = function (sourceUrl, filename) { return __awaiter(void 0, void 0, void 0, function () {
    var blob;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(sourceUrl).then(function (r) { return r.blob(); })];
            case 1:
                blob = _a.sent();
                downloadFileFromBlob(blob, filename);
                return [2 /*return*/];
        }
    });
}); };
/**
 * Download File from Blob triggers a download of the provided file blob with the specified filename.
 *
 * @param blob     The file blob to download
 * @param filename The name of the downloaded file
 */
export var downloadFileFromBlob = function (blob, filename) {
    var _a;
    var url = window.URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    (_a = link.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(link);
};
